import {
  Component,
  ElementRef,
  Injectable,
  Input,
  OnInit,
  Pipe,
  PipeTransform,
  ChangeDetectionStrategy
} from '@angular/core';
import CommitteeVoteType from '../committee-votes/committee-vote/committee-vote-type';
import Project from '../../interfaces/project';
import Milestone from '../../interfaces/milestone';
import { CommitteeApprovalType } from '../committee-approvals/committee-approval-type';
import { PipelineProject } from '../../interfaces/pipeline-project';
import { CommitteeItemsService } from '../committee-items/committee-items.service';
import moment from 'moment';
import { UserPermissionsService } from 'src/app/services/user-permissions.service';
import { get_committee_dashboard_by_project } from '../../deals/deals-committee-dashboard/graphql/getCommitteeDashboardByProject';
import { Apollo } from 'apollo-angular';
import { CommitteeApprovalDashboardService } from '../committee-approval-dashboard.service';
import { DataFormatService } from 'src/app/services/data-format.service';

import { formatCurrency } from '@angular/common';
import ProjectDisclosure from 'src/app/interfaces/project-disclosure';

const GET_COMMITTEE_DASHBOARD_BY_PROJECT = get_committee_dashboard_by_project;

@Component({
    selector: 'app-milestone-sections',
    templateUrl: './milestone-sections.component.html',
    styleUrls: ['./milestone-sections.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MilestoneSectionsComponent implements OnInit {
  @Input('voteTypes') voteTypes: CommitteeVoteType[];
  @Input('project') project: Project;
  @Input('milestone') milestone: Milestone;
  @Input('approvalTypes') approvalTypes: CommitteeApprovalType[];
  @Input('currentMilestone') currentMilestone?: Milestone;
  @Input('milestones') milestones: Milestone[];
  @Input('disclosure') disclosure: ProjectDisclosure;
  @Input('readOnly') readOnly:boolean;

  public isCollapsed: boolean = false;
  public printSelf: boolean = false;
  public printingProject: any;
  public legalid: any;
  public votingMilestone:any;
  public pipelineProjectDates:Array<any> = []
  constructor(
    public dashboardService: CommitteeApprovalDashboardService,
    public dataFormat: DataFormatService,
    public apollo: Apollo,
    public itemsService: CommitteeItemsService,
    public perms: UserPermissionsService,
    private element: ElementRef
  ) {}

  ngOnInit(): void {
    this.perms.getUserPermissions('PROJECT', null);
    if (this.currentMilestone) {
      this.isCollapsed = this.currentMilestone.id !== this.milestone.id;
    }
    for (let i = 0; i < this.approvalTypes.length; i += 1) {
      if (this.approvalTypes[i].name === 'Legal') {
        this.legalid = this.approvalTypes[i].id;
        this.perms.getUserPermissions('COMMITTEEAPPROVALTYPE', this.legalid);
      }
    }

    this.votingMilestone = this.milestone
    if(this.milestone.name.toLowerCase()=='closed' && this.milestones.length>1){
      this.votingMilestone = this.milestones.filter((milestone) => milestone.name.toLowerCase()=='capital committee')[0]
    }
    this.setPipelineDateByMilestone()
  }

  print(s: string) {
    let query = this.apollo
      .query<any>({
        query: GET_COMMITTEE_DASHBOARD_BY_PROJECT,
        fetchPolicy: 'no-cache',
        variables: {
          projectid: this.project.id,
          milestoneNames: [
            'Placement Committee Reviewed',
            'Capital Committee',
            'Screening Committee',
          ],
        },
      })
      .subscribe(({ data }) => {
        this.format(data);
        query.unsubscribe();
        this.printSelf = false;
        setTimeout(() => {
          this.printSelf = true;

          setTimeout(() => {
            let el = document.getElementById(s);
          }, 1200);
        }, 300);
      });
  }

  getMilestoneDate(): string {
    let date = '';
    if (this.project.pipelineProjects && this.project.pipelineProjects.length) {
      if (this.project.pipelineProjects) {
        this.project.pipelineProjects?.forEach(
          (pipelineProject: PipelineProject) => {
            let pipelineProjectDate =
              pipelineProject.pipelineProjectDates?.filter(
                (ppd: any) =>
                  ppd.pipelineMilestone.milestone.id === this.milestone.id
              )[0];
            if (pipelineProjectDate && date.length === 0) {
              date +=
                ': ' + moment(pipelineProjectDate.date).format('MM/DD/YYYY');
            }
          }
        );
      } else {
        date = ': TBD';
      }
    }
    return date;
  }

  getDisclosureForMilestone(
    disclosures: ProjectDisclosure[],
    milestone: Milestone
  ) {
    let index = disclosures.findIndex(
      (disclosure: ProjectDisclosure) =>
        disclosure.milestone_id === milestone.id
    );

    if (index > -1) {
      return disclosures[index];
    } else {
      return {
        id: 'new',
        disclosures: '',
        milestone_id: milestone.id,
        project_id: this.project.id,
      };
    }
  }

  setPipelineDateByMilestone(){
    if(this.project.pipelineProjects){
      for(let i = 0; i < this.project.pipelineProjects.length; i++){
        let projectDates = this.project.pipelineProjects[i].pipelineProjectDates;
        for(let g = 0; g < projectDates.length; g++){
          if(projectDates[g] && projectDates[g]?.pipelineMilestone?.milestone?.id == this.milestone?.id){
            this.pipelineProjectDates.push(projectDates[g])
          }
        }
      }
    }
  }

  //I didn't want to do it this way.

  format(data: any) {
    if (data.hasOwnProperty('pipelineMilestoneDates')) {
      let count = 0;
      for (let i = 0; i < data.pipelineMilestoneDates.length; i++) {
        for (
          let j = 0;
          j < data.pipelineMilestoneDates[i].pipelineProjectDates.length;
          j++
        ) {
          let project =
            data.pipelineMilestoneDates[i].pipelineProjectDates[j]
              .pipelineProject.project;
          let temp: any = {
            projectName: project.name,
            projectid: project.id,
            id: project.id,
            projecturl: this.dataFormat.formatLink(project),
            sharepointfolder: project.sharepoint_folder,
            islinked: project.is_synced_link,
            projectStatus: '',
            expand: true,
            key: project.id,
            committeeDate: moment
              .utc(data.pipelineMilestoneDates[i].pipelineProjectDates[j].date)
              .format('MM/DD/YYYY'),
            committeeName:
              data.pipelineMilestoneDates[i].pipelineProjectDates[j]
                .pipelineMilestone.milestone.name,
            milestone:
              data.pipelineMilestoneDates[i].pipelineProjectDates[j]
                .pipelineMilestone.milestone,
            info: [],
            creditTypes: [],
            creditOutlets: [],
            disclosures: project.disclosures,
            project: project,
            committeeLinks: project.committeeLinks,
            votes: project.committeeVotes,
            approvals: project.committeeApprovals,
          };

          //this.itemsService.addItemsFromApi(project.id, project.committeeItems ?? []);
          if (project.projectStatuses !== null) {
            temp.projectStatus = project.projectStatuses[0].status.name;
          }

          //Account Manager and Developer
          if (project.participants !== null) {
            if (
              this.dashboardService.getParticipant(
                project.participants,
                'Account Manager'
              ) !== null
            ) {
              temp.info.push(
                this.dashboardService.getParticipant(
                  project.participants,
                  'Account Manager'
                )
              );
            } else {
              temp.info.push({ key: 'Account Manager', value: 'N/A' });
            }
            if (
              this.dashboardService.getParticipant(
                project.participants,
                'Developer'
              ) !== null
            ) {
              temp.info.push(
                this.dashboardService.getParticipant(
                  project.participants,
                  'Developer'
                )
              );
            } else {
              temp.info.push({ key: 'Developer/Sponsor', value: 'N/A' });
            }
          }

          //Closing Date
          if (project.pipelineProjects !== null) {
            let closing = null;
            for (let k = 0; k < project.pipelineProjects.length; k++) {
              if (
                project.pipelineProjects[0].closingDate !== null &&
                project.pipelineProjects[0].closingDate.length > 0
              ) {
                closing = moment
                  .utc(project.pipelineProjects[0].closingDate[0].date)
                  .format('MM/DD/YYYY');
                temp.info.push({ key: 'Closing Date', value: closing });
              }
            }
            if (closing === null) {
              temp.info.push({ key: 'Closing Date', value: 'N/A' });
            }
          }

          //Total Units
          if (!!project.properties?.length) {
            temp.info.push({
              key: 'Total Units',
              value: project.properties[0].total_units,
            });
          }

          //Credit Types and Credit Outlets
          let equity: number = 0;
          if (project.projectCredits !== null) {
            // temp.info.push({key: 'Credit Types', value: this.dataFormat.formatCreditTypes(project.projectCredits, false)});
            // temp.info.push({key: 'Credit Outlets', value: this.dataFormat.formatCreditOutlets(project.projectCredits)});
            temp.creditTypes = this.dataFormat.formatCreditTypes(
              project.projectCredits,
              false
            );
            temp.creditOutlets = this.dataFormat.formatCreditOutlets(
              project.projectCredits
            );
            equity = this.dashboardService.getLTEquity(project);
          }

          //Originator
          if (
            project.participants !== null &&
            this.dashboardService.getParticipant(
              project.participants,
              'Originator'
            ) !== null
          ) {
            temp.info.push(
              this.dashboardService.getParticipant(
                project.participants,
                'Originator'
              )
            );
          }
          temp.info.push({
            key: 'Repeat Developer',
            value: project.isRepeatDeveloper ? 'Yes' : 'No',
          });
          //LTEquity
          temp.info.push({
            key: 'LT Equity',
            value: formatCurrency(equity, 'en-US', '$', undefined, '1.0-0'),
          });

          //City/State
          if (
            !!project?.properties[0]?.entity?.entityAddresses?.address?.zipCode
          ) {
            temp.info.push({
              key: 'City/State',
              value:
                project.properties[0].entity.entityAddresses[0].address.zipCode
                  .city +
                ', ' +
                project.properties[0].entity.entityAddresses[0].address.zipCode
                  .state.abbreviation,
            });
          }

          this.printingProject = temp.project;
        }
      }
    }
  }
}

@Pipe({
    name: 'approval_filter',
    standalone: false
})
@Injectable()
export class ApprovalFilter implements PipeTransform {
  transform(statuses: any[], args: any[]): any {
    return statuses.filter((status) => {
      return true;
    });
  }
}
